import React from 'react'
import { Box } from '@material-ui/core'
import SEO from "../components/seo"
import Layout from "../components/Layout/"
import ScholarshipLayout from '../components/Layout/ScholarshipLayout'

const Scholarships = () => {
    return (
        <>
            <SEO title="Scholarships" />
            <Layout withFooter withHeader>
                <Box>
                    <ScholarshipLayout />
                </Box>
            </Layout>
        </>
    )
}

export default Scholarships
